import BootstrapVue from 'bootstrap-vue'
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import VueCookies from 'vue-cookies'
import Vuex from 'vuex'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import router from './router'
import './styles/_main.scss'
import VuexStore from './vuex/store'
window.$ = window.jQuery = require('jquery')
import '../gtm'
import Clarity from '@microsoft/clarity'

Clarity.init(process.env.VUE_APP_CLARITY_PROJECT_ID)

Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(VueCookies)
Vue.config.productionTip = false
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA,
  router,
  debug: {
    enabled: false,
    trace: false,
    sendHitTask: true
  }
})

const store = new Vuex.Store(VuexStore)

sync(store, router)

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
